import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ErrorIcon from '@mui/icons-material/ErrorRounded';
import { Box, CircularProgress, Fade } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import Tooltip from '../../../Tooltip';
import { SearchStatus } from '../../interfaces/search-status.enum';
import { SearchStatusAdornmentProps } from './searchStatusAdornment.types';

const SearchStatusAdornment = ({ status, isLoading, errorMessage }: SearchStatusAdornmentProps) => {
  const { translate } = useTranslation();

  const getAdornment = () => {
    if (isLoading) {
      return (
        <Fade in>
          <CircularProgress size={20} color="primary" />
        </Fade>
      );
    }
    if (status === SearchStatus.ERROR) {
      return (
        <Tooltip
          title={translate(errorMessage || LangEnum.API_EXCEPTION_PRODUCT_NOT_FOUND)}
          placement="bottom"
          backgroundColor="error"
          arrow
        >
          <Fade in>
            <ErrorIcon
              fontSize="small"
              color="error"
              onClick={(event) => {
                event.stopPropagation();
              }}
            />
          </Fade>
        </Tooltip>
      );
    }
    if (status === SearchStatus.SUCCESS) {
      return (
        <Fade in>
          <CheckRoundedIcon fontSize="small" color="primary" />
        </Fade>
      );
    }
    return null;
  };

  return (
    <Box
      sx={{
        width: 20,
        height: 20,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {getAdornment()}
    </Box>
  );
};

export default SearchStatusAdornment;
